<template>
  <div
    class="question_answer collapse"
    :class="{
      show: isOpen,
      notShowQa: c_isNotShowQa,
      'click-btn-higher': c_isVideoCpnt,
    }"
    :id="`${id}-qa`"
  >
    <div class="clickable-button">
      <!-- <div class="layer bg-info shadow"></div> -->
      <a
        aria-expanded="false"
        aria-controls="question_answer"
        class="floating-open bg-info text-white"
        href="javascript:undefined"
        @click.prevent="openAsk"
      >
        <i class="pz-icon icon-issue"></i>
      </a>
    </div>
    <div class="clickable-button" id="hideAsk">
      <!-- <div class="layer bg-info shadow"></div> -->
      <a
        aria-expanded="false"
        aria-controls="question_answer"
        class="floating-open bg-info text-white"
        href="javascript:undefined"
        @click.prevent="hideAsk"
      >
        <i class="pz-icon icon-chevron-left"></i>
      </a>
    </div>
    <div class="layered-content bg-white">
      <header
        class="d-flex justify-content-between border-bottom bg-light py-3"
      >
        <!-- 相关问题 - 标题 -->
        <div v-if="!isShowQa">
          <h5>
            列表里是其他学员针对该{{ c_isVideoCpnt ? '视频' : '题' }}的提问
          </h5>
          <p class="text-info mb-0">
            我们对新问题的解答需要一些时间，请先看看列表里有没有和您相似的问题
          </p>
        </div>
        <!-- 提问 - 标题 -->
        <div v-if="isShowQa">
          <h5 class="modal-title">提问</h5>
        </div>
        <div class="clickable-close-button text-center">
          <a
            aria-expanded="false"
            aria-controls="question_answer"
            class="text-dark"
            href="javascript:undefined"
            @click.prevent="closeAsk"
          >
            <i class="pz-icon icon-close"></i>
          </a>
        </div>
      </header>
      <main class="overflow-content">
        <div class="QALoading" v-if="c_isShowSpinner">
          <Spinner
            displayType="inline"
            text="加载相关问题 ..."
            questionClass="question"
          />
        </div>
        <template v-if="!c_isShowSpinner">
          <!-- 相关问题 -->
          <qa-referal-list v-if="!isShowQa" />
          <!-- 提问 -->
          <form class="h-100 border-0" v-if="isShowQa">
            <qa-tags v-if="c_isNeedQaTags" />
            <qa-limit
              :p_selectedTag="c_selectedTag"
              v-if="c_selectedTag.qaChanceLimit"
            />
            <qa-title v-model="qaTitle" />
            <qa-content
              style="height: calc(100% - 61px)"
              :typeOfEditor="typeOfEditor"
              :player="player"
              v-model="qaContent"
              @image-added="handleImageAdded"
              ref="QaContent"
            />
          </form>
        </template>
      </main>
      <footer class="modal-footer justify-content-right">
        <!-- <ul class="modal-footer-right list-inline">
          <li class="list-inline-item">
            {{ isShowQa ? '请至少输入10个有效字符进行提问。' : '' }}
          </li>
        </ul> -->

        <ul class="modal-footer-right list-inline">
          <li class="list-inline-item" v-if="!isShowQa">
            <button
              type="button"
              class="btn btn-primary px-4"
              @click.prevent="openQA"
            >
              继续提问
            </button>
          </li>
          <li
            class="list-inline-item d-flex align-items-center"
            v-if="isShowQa"
          >
            <div
              class="custom-control custom-switch d-flex align-items-center mr-4"
            >
              <input
                type="checkbox"
                class="custom-control-input"
                id="customSwitch1"
                v-model="sendSmsNotification"
                @change="setSendSmsNotification"
              />
              <label class="custom-control-label small" for="customSwitch1"
                >当有回答或评论时是否接收短信通知？</label
              >
            </div>
            <button
              type="button"
              class="btn btn-info px-4"
              :disabled="c_isSubmitDisabled"
              @click.prevent="postQA"
            >
              {{ submitting ? '发布中...' : '发布' }}
            </button>
          </li>
        </ul>
      </footer>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
//import _ from 'lodash';

import Spinner from '@/components/Spinner.vue';

import { QaReferalListMixin } from '@/mixins/QA/ReferalList';
import { QaMixin } from '@/mixins/QA/QA';
import { QaAskMixin } from '@/mixins/QA/QaAsk';
import { QaSendSmsNotificationMixin } from '@/mixins/Setting/QaSendSmsNotification';
import { VideoExerciseMixin } from '@/mixins/NoteQA/VideoExercise';

export default {
  name: 'QA',

  components: {
    Spinner,
  },

  mixins: [
    //
    QaReferalListMixin,
    QaMixin,
    QaAskMixin,
    QaSendSmsNotificationMixin,
    VideoExerciseMixin,
  ],

  props: {
    id: {
      type: String,
      default: () => 'pz-question',
    },

    typeOfEditor: {
      type: String,
      default: () => 'EXERCISE_QA',
    },
  },

  data() {
    return {
      isGotReferralListAndTagInfo: false,
      isWaitingQaBulletTags: false,
      promiseGetQaBulletTags: null,
      tagInfo: {},

      isOpen: false,
      isOpened: false,
    };
  },

  computed: {
    ...mapState('Mixins/QA', {
      ms_qaBulletTags: 'qaBulletTags',
    }),

    c_courseId() {
      if (this.c_isVideoCpnt) {
        return parseInt(this.$route.params.courseId);
      } else {
        return this.Question.courseId;
      }
    },

    c_isNotShowQa() {
      return !this.isOpen || !this.isShowQa;
    },

    c_isShowSpinner() {
      return this.ms_isReferalListLoading || this.isWaitingQaBulletTags;
    },

    c_isNeedQaTags() {
      return this.c_isVideoCpnt && false === this.tagInfo.hasCourseBookTag;
    },

    ///
    c_isSelectedTag() {
      if (!this.c_isNeedQaTags) {
        return true;
      } else {
        return this.mg_isSelectedTag;
      }
    },

    ///
    _c_selectedTag() {
      if (!this.c_isNeedQaTags) {
        return this.tagInfo;
      } else {
        return this.mg_selectedTag;
      }
    },

    ///
    c_isNeedSubTag() {
      if (!this.c_isNeedQaTags) {
        return true;
      } else {
        return this.mg_isNeedSubTag;
      }
    },

    ///
    c_isSelectedSubTag() {
      if (!this.c_isNeedQaTags) {
        return true;
      } else {
        return this.mg_isSelectedSubTag;
      }
    },

    ///
    c_selectedTagId() {
      if (!this.c_isNeedQaTags) {
        return this.c_selectedTag.courseTagId;
      } else {
        return this.ms_selectedTagId;
      }
    },

    ///
    c_selectedSubTagId() {
      if (!this.c_isNeedQaTags) {
        return this.c_selectedTag.bookTagId;
      } else {
        return this.ms_selectedSubTagId;
      }
    },

    c_exerciseQaContent() {
      let content = '';
      if (this.c_isExerciseCpnt) {
        const sqaTitleQuestionNo = `<p><i><b>NO.PZ${this.c_Question.source}</b></i></p>`;
        const {
          //
          imageQuestionHtml,
          imageOption0Html,
          imageOptionaHtml,
          imageOptionbHtml,
          imageOptioncHtml,
          imageOptiondHtml,
          imageOptioneHtml,
          imageExplainHtml,
        } = this.c_Question.detail;
        content = `<div ignore-attr='true'>
          <p><i><b>问题如下：</b></i></p>
          ${imageQuestionHtml}
          <p><i><b>选项：</b></i></p>
          ${imageOption0Html ? imageOption0Html : ''}
          ${imageOptionaHtml ? '<span>A.</span>' + imageOptionaHtml : ''}
          ${imageOptionbHtml ? '<span>B.</span>' + imageOptionbHtml : ''}
          ${imageOptioncHtml ? '<span>C.</span>' + imageOptioncHtml : ''}
          ${imageOptiondHtml ? '<span>D.</span>' + imageOptiondHtml : ''}
          ${imageOptioneHtml ? '<span>E.</span>' + imageOptioneHtml : ''}
          <p><i><b>解释：</b></i></p>
          ${imageExplainHtml}
          </div>`;
        content = sqaTitleQuestionNo + content;
      }
      return content;
    },
  },

  methods: {
    ...mapActions('Mixins/QA', {
      ma_getQaBulletTags: 'getQaBulletTags',
      ma_doQuestionBulletNew: 'doQuestionBulletNew',
      ma_saveQuestionQA: 'saveQuestionQA',
    }),

    getReferralList() {
      if (this.c_isVideoCpnt) {
        this.promiseGetReferralList = this.ma_getQaBulletListReferal({
          bulletId: this.c_bulletId,
        });
      } else {
        this.promiseGetReferralList = this.ma_getQuestionReferral({
          questionId: this.c_QuestionId,
        });
      }
    },

    async getTagInfo() {
      if (this.c_isVideoCpnt) {
        if (this.c_bulletId !== this.tagInfo.bulletId) {
          this.promiseGetQaBulletTags = this.ma_getQaBulletTags({
            courseId: this.c_courseId,
            bulletId: this.c_bulletId,
          });
          await this.promiseGetQaBulletTags;
          this.tagInfo = {
            ...this.ms_qaBulletTags,
            bulletId: this.c_bulletId,
          };
        }
      } else {
        if (this.c_isQuestionXL) {
          if (this.c_Question.groupId !== this.tagInfo.groupId) {
            this.tagInfo = {
              ...this.Question.subQuestions[0].tagInfo,
              groupId: this.Question.subQuestions[0].groupId,
            };
          }
        } else {
          if (this.c_Question.questionId !== this.tagInfo.questionId) {
            this.tagInfo = {
              ...this.Question.tagInfo,
              questionId: this.Question.questionId,
            };
          }
        }
        this.tagInfo = {
          ...this.tagInfo,
          canPostQA: this.Question.canPostQA,
          courseTagId: this.c_Question.courseTagId,
          bookTagId: this.c_Question.bookTagId,
        };
      }
    },

    async openAsk() {
      if (this.isOpened) {
        this.isOpen = true;
      } else {
        if (!this.isGotReferralListAndTagInfo) {
          this.getReferralList();
          this.getTagInfo();
          this.isGotReferralListAndTagInfo = true;
        }
        await this.promiseGetReferralList;
        if (0 === this.mg_referalList.length) {
          this.openQA();
          await this.promiseGetQaBulletTags;
          this.isOpen = this.isShowQa;
        } else {
          this.isOpen = true;
        }
        this.isOpened = this.isOpen;
      }
      if (this.isOpen) {
        this.$emit('qa-opened', true);
        // $(`#${this.id}-qa`).modal({ backdrop: false, show: true });
      }
    },

    hideAsk() {
      this.$emit('qa-opened', false);
      this.isOpen = false;
    },

    ///
    async doOpenQA() {
      if (this.c_isVideoCpnt) {
        this.isWaitingQaBulletTags = true;
        await this.promiseGetQaBulletTags;
        this.isWaitingQaBulletTags = false;
        if (!this.tagInfo.canPostQA) {
          this.swalNotCanPostQA();
          return;
        }
        this.isShowQa = true;
        await this.$nextTick();
        this.$refs.QaContent.insertCurrentTimeTagAndCapture();
      } else {
        if (!this.tagInfo.canPostQA) {
          this.swalNotCanPostQA();
          return;
        }
        this.isShowQa = true;
      }
    },

    ///
    async doPostQA() {
      if (this.c_isVideoCpnt) {
        await this.ma_doQuestionBulletNew({
          tagIds: this.c_selectedTagsId,
          qaTitle: this.qaTitle,
          qaContent: this.qaContent,
          courseId: this.c_courseId,
          bulletId: this.c_bulletId,
        });
      } else {
        await this.ma_saveQuestionQA({
          tagIds: this.c_selectedTagsId,
          qaTitle: this.qaTitle,
          qaContent: this.c_exerciseQaContent + this.qaContent,
          courseId: this.c_courseId,
          questionId: this.c_QuestionId,
        });
      }
    },

    ///
    doAfterPostQaSuccess() {
      if (this.tagInfo.qaChanceLimit) {
        if (this.tagInfo.askingChances > 0) {
          const { askingChances } = this.tagInfo;
          this.tagInfo = {
            ...this.tagInfo,
            askingChances: askingChances - 1,
          };
        } else {
          const {
            //
            bonusPoint,
            pointsPerQuestion,
            bonusPointMoney,
          } = this.tagInfo;
          this.tagInfo = {
            ...this.tagInfo,
            bonusPoint: bonusPoint - pointsPerQuestion,
            bonusPointMoney: bonusPointMoney - pointsPerQuestion / 10,
          };
        }
      }
    },

    ///
    closeQA() {
      this.hideAsk();
      this.isOpened = false;
      this.isShowQa = false;
    },

    closeAsk() {
      this.closeQA();
    },

    ///
    reset() {
      if (this.c_isNeedReset) {
        this.closeQA();
        this.isGotReferralListAndTagInfo = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.ofHidden.ofHidden.ofHidden {
  display: none !important;
}
.my-editor {
  padding: 0;
  border-top: 0;
}
.QALoading {
  text-align: center;
}
.question_answer .clickable-button#hideAsk {
  position: absolute;
  width: 56px;
  /* height: calc(100% - 70px); */
  right: 20px;
  top: 130px;
  bottom: 80px;
  z-index: 1031;
  transform-origin: center;
  transform: none;
  transition: 0.3s all ease 0.6s;
}

.question_answer .clickable-button#hideAsk .layer {
  position: absolute;
  right: 0px;
  bottom: 10px;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  pointer-events: none;
  z-index: -99;
  transition: 0.3s all ease 0.3s;
  transform-origin: center;
  transform: none;
}

.question_answer .clickable-button#hideAsk .floating-open {
  position: absolute;
  right: 0px;
  bottom: 10px;
  z-index: 10;
  transition: 0.3s all ease 0.6s;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  border: 0;
  -webkit-mask-image: -webkit-radial-gradient(circle, white, black);
  display: flex;
  justify-content: center;
  align-items: center;
  color: #333;
  text-decoration: none;
  pointer-events: auto;
}

.question_answer.notShowQa .clickable-button#hideAsk {
  right: 0;
  bottom: 0;
  z-index: -3;
  transition: 0.3s all ease;
  transform: rotate(90deg) translateY(48px);
}

.question_answer.notShowQa .clickable-button#hideAsk .layer {
  transform: scale(100);
  transition: 1.5s all ease 0.3s;
}

.question_answer.notShowQa .clickable-button#hideAsk .floating-open {
  pointer-events: none;
  opacity: 1;
  z-index: 100;
  transition: none;
}

.question_answer.click-btn-higher {
  .clickable-button {
    .layer {
      bottom: 30px;
    }
    .floating-open {
      bottom: 30px;
    }
  }
}
</style>
